import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _dec2, _dec3, _class, _class2, _descriptor;
/*
 *                     NOTICE
 *            COPYRIGHT 2024 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import * as AbReactResources from "abreact/generated/locale/AbReactResources";
import { AbPopup } from "abreact/incubator/ui/popup/AbPopup";
import { PopupUtils } from "abreact/incubator/ui/popup/PopupUtils";
import { AbLocalToolbar, AbLocalToolbarGroup } from "abreact/incubator/ui/toolbar/AbLocalToolbar";
import { CssUtils } from "abreact/incubator/ui/utils/CssUtils";
import { MouseMoveTracker } from "abreact/incubator/ui/utils/MouseMoveTracker";
import { AbButton } from "abreact/misc/AbButton";
import { action, makeObservable, observable } from "mobx";
import { observer } from "mobx-react";
import React from "react";
/**
 * AbMarkdownImage
 * The component that renders images for AbMarkdownEditor
 *
 * @deprecated Replace {@link AbMarkdownEditor} with {@link AbMarkdownLexical} markdown editor and its child component {@link ImageComponent}
 */
export let AbMarkdownImage = (_dec = action.bound, _dec2 = action.bound, _dec3 = action.bound, observer(_class = (_class2 = class AbMarkdownImage extends React.Component {
  constructor(props) {
    super(props);
    _initializerDefineProperty(this, "showSelection", _descriptor, this);
    _defineProperty(this, "spanRef", null);
    _defineProperty(this, "imgRef", null);
    this.showSelection = false;
    makeObservable(this);
  }
  onClick(event) {
    this.showSelection = true;
    this.props.containingEditor.setSelection(this.props.blockKey, this.props.start);
  }
  editImage(event) {
    this.showSelection = false;
    this.props.containingEditor.editImage();
  }
  deleteImage(event) {
    this.showSelection = false;
    this.props.containingEditor.deleteLink();
  }
  changeSize(width, height) {
    this.props.containingEditor.changeSize(width.toString(), height.toString());
  }
  startResize(event) {
    event.stopPropagation();
    const resizeHandleDiv = event.target;
    const container = resizeHandleDiv.parentElement;
    const width = container.offsetWidth;
    const height = container.offsetHeight;
    const startX = event.clientX;
    const startY = event.clientY;
    const tracker = new MouseMoveTracker(resizeHandleDiv);
    const cursor = "se-resize";
    const WINDOW_MARGIN = 20;
    tracker.track(event.nativeEvent, (dx, dy) => {
      if (startX + dx - WINDOW_MARGIN < 0) dx = -startX + WINDOW_MARGIN;
      if (startX + dx + WINDOW_MARGIN > container.ownerDocument?.defaultView.innerWidth) dx = container.ownerDocument.defaultView.innerWidth - startX - WINDOW_MARGIN;
      if (startY + dy - WINDOW_MARGIN < 0) dy = -startY + WINDOW_MARGIN;
      if (startY + dy + WINDOW_MARGIN > container.ownerDocument?.defaultView.innerHeight) dy = container.ownerDocument?.defaultView.innerHeight - startY - WINDOW_MARGIN;
      container.style.width = `${width + dx}px`;
      container.style.height = `${height + dy}px`;
      this.imgRef.width = parseInt(container.style.width);
      this.imgRef.height = parseInt(container.style.height);
    }, () => {
      console.log(`resizeReleased: (${container.style.width},${container.style.height})`);
      container.style.width = "auto";
      container.style.height = "auto";
      this.changeSize(this.imgRef.width, this.imgRef.height);
    }, cursor);
  }
  render() {
    const data = this.props.contentState.getEntity(this.props.entityKey).getData();
    const src = data.src;
    const alt = data.alt;
    let url;
    try {
      url = new URL(src);
    } catch (e) {
      // not a URL? make a fake one for width and height
      url = new URL("invalid:url");
    }
    // query params: width and height
    const width = url.searchParams.get("width") ?? undefined;
    const height = url.searchParams.get("height") ?? undefined;
    const imgClassName = this.showSelection ? "ab-markdown-image-selection-opacity" : undefined;
    const resizable = url.protocol !== "data:";
    return /*#__PURE__*/React.createElement("span", {
      className: CssUtils.composeClassNames("ab-markdown-image", this.showSelection && "ab-markdown-image-selection"),
      ref: x => this.spanRef = x,
      onClick: this.onClick,
      "data-entity-key": this.props.entityKey,
      "data-offset-key": this.props.offsetKey
    }, "\u200b", /*#__PURE__*/React.createElement("img", {
      ref: x => this.imgRef = x,
      src: src,
      alt: alt,
      className: imgClassName,
      role: "presentation",
      width: width,
      height: height
    }), /*#__PURE__*/React.createElement("div", {
      className: "ab-markdown-image-bottom-right-handle",
      style: {
        display: this.showSelection && resizable ? undefined : "none"
      },
      onMouseDown: e => this.startResize(e)
    }), "\u200b", this.showSelection && /*#__PURE__*/React.createElement(AbPopup, {
      className: "ab-markdown-popup-toolbar",
      origin: this.spanRef || undefined,
      positioner: PopupUtils.VERTICAL_FIXED_SIZE_POSITIONER,
      flushContent: true,
      overlay: false,
      onClose: action(() => this.showSelection = false),
      closeOnBackgroundClick: true
    }, /*#__PURE__*/React.createElement(AbLocalToolbar, {
      type: "stand-alone"
    }, /*#__PURE__*/React.createElement(AbLocalToolbarGroup, null, /*#__PURE__*/React.createElement(AbButton, {
      onClick: this.editImage,
      label: AbReactResources.markdownEditor_editImage()
    }), /*#__PURE__*/React.createElement(AbButton, {
      onClick: this.deleteImage,
      label: AbReactResources.markdownEditor_deleteImage()
    })))));
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "showSelection", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "onClick", [_dec], Object.getOwnPropertyDescriptor(_class2.prototype, "onClick"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "editImage", [_dec2], Object.getOwnPropertyDescriptor(_class2.prototype, "editImage"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "deleteImage", [_dec3], Object.getOwnPropertyDescriptor(_class2.prototype, "deleteImage"), _class2.prototype), _class2)) || _class);
//# sourceMappingURL=AbMarkdownImage.js.map
